<template>
      <div class="home" v-loading="!isInit"  element-loading-background="rgba(0, 0, 0, 0.8)"
           element-loading-spinner="el-icon-loading"
           element-loading-text="加载中..."
           style="display: flex;flex-direction: column;height: 100%;">
        <indexPage v-if="isInit&&!example" ></indexPage>
        <indexPageExample v-if="isInit&&example" ></indexPageExample>

      </div>
</template>

<script>
import indexPage from "@/views/indexPage";
import indexPageExample from "@/views/indexPageExample";
import {mapMutations, mapState} from "vuex";
export default {
  name: 'Home',
  components: {
    indexPage,indexPageExample
  },
  data() {
    return {
      isInit: false
    }
  },
  created() {
    let params = this.$route.params;
    if(params.init && this.isLogin){
      // 该系统其他页面返回
      this.isInit = true;
    }else{
      //标事通发送消息  是否登录
      window.addEventListener("message", this.handleMessage, false);
    }

    // this.handleMessageBst()
  },
  methods: {
    handleMessageBst() {
      let data;
      let json =  {
        "source": "biaoshitong",
        "vipServerId": "all",
        "type": "similarity",
        "id": "1762648482859114498",
        "example": false,
        "token": "refreshToken:eyJhbGciOiJIUzUxMiIsInppcCI6IkRFRiJ9.eNoci0sOwyAMBe_idZAwMsbkHLkAFdDSTxKFRGpV9e6FLN_Mmy_c9wIjMFO2iKJY56AoCKngo1M6oHEi6CNbGKAel3ZGx4ZJSIxYj0jkpblSa3MhvsrcV9hhROecsewtDZDeawdiiPQJ9s-aWrClvKV6m5ZH6t1zuZZ5OpX5_QEAAP__.6zZP_nNWwNxHaoYLXhv5LyFMr4MBM0RURx0NCXJuBLFObZex62MIzGb3MXutPGWr1kqRg3OpUfxBnW5-ZtNmcQ",
        "nickName": "ASIAN",
        "useraccount": "18404984585"
      }
      const e = {
        data: JSON.stringify(json)
      }
      if (typeof e.data == "string" && e.data) {
        try {
          data = JSON.parse(e.data);
        } catch (err) {
          data = {};
        }
      } else if (typeof e.data == "object") {
        data = e.data;
      }
      if (data.source == "biaoshitong") {
        this.setsrcSymbol("biaoshitong")
        if (data.type == "similarity") {
          this.init(data)
        }
      }else if(data.source =='xingqiao'){
        if(data.hasOwnProperty('vipServerId') && data.vipServerId == 'sx'){
          this.setsrcSymbol("jiubang")
        }else{
          this.setsrcSymbol("xingqiao")
        }
        if (data.type == "similarity") {
          this.init(data)
        }
      }
    },
    
    handleMessage(e) {
      console.log(e)
      let data;
      console.log(JSON.parse(e.data))
      if (typeof e.data == "string" && e.data) {
        try {
          data = JSON.parse(e.data);
        } catch (err) {
          data = {};
        }
      } else if (typeof e.data == "object") {
        data = e.data;
      }
      if (data.source == "biaoshitong") {
        this.setsrcSymbol("biaoshitong")
        if (data.type == "similarity") {
          this.init(data)
        }
      }else if(data.source =='xingqiao'){
        if(data.hasOwnProperty('vipServerId') && data.vipServerId == 'sx'){
          this.setsrcSymbol("jiubang")
        }else{
          this.setsrcSymbol("xingqiao")
        }
        if (data.type == "similarity") {
          this.init(data)
        }
      }
    },
    init(data){
      try {
        let token = data.token ? data.token : null;
        let id = data.id ? data.id : null;
        let nickName = data.nickName ? data.nickName : null;
        let useraccount = data.useraccount ? data.useraccount : null;
        if (token && id) {
          this.setUserId(id);
          this.setExample(data.example);
          this.setToken(token);
          this.setUserAccount(useraccount)
          this.setNickName(nickName);
          this.changeLogin(true);
          this.isInit = true;
        } else {
          this.setUserId(null);
          this.setToken(null);
          this.setUserAccount(useraccount)
          this.setExample(false);
          this.setNickName(null);
          this.changeLogin(false);
        }
      } catch (err) {
        this.changeLogin(false);
        this.setUserId(null);
        this.setToken(null);
        this.setUserAccount(null)
        this.setNickName(null);
      }
      if(!this.isLogin){
        let data = {
          source: "similarity",
          info: {
            actionType: 1, //  1需要登录
          },
        };
        window.parent.postMessage(JSON.stringify(data), "*");
      }
    },
    ...mapMutations("user",["changeLogin",'setUserId','setNickName','setToken','setsrcSymbol','setExample','setUserAccount'])
  },
  computed:{
    ...mapState("user",['isLogin','example'])
  }
}
</script>

<style lang="scss" scoped>
.home {
  flex: 1;
  height: 1px;
  display: flex;
  flex-direction: column;
}
</style>
